import { ElementRef, NgZone } from '@angular/core';
import { MessageService } from '../../message/message.service';
import { SessionStorageService } from 'ngx-webstorage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RatingService } from '../../rating/rating.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OfflineMessageService } from './offline-message.service';
import { UserService } from '../../../core/user/user.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { DomSanitizer } from "@angular/platform-browser";
import { TRANSLATED_LOGINS } from '../../../app.constants';
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from '../../../core/auth/account.service';
import { CustomerCareInfoModalComponent } from '../../session/offline-message/customer-care-info-modal.component';
import moment from 'moment';
import { SessionChatComponent } from '../../session/session-chat-coach/session-chat.component';
import { SessionService } from '../../session/session.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../session/session.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "../../message/message.service";
import * as i4 from "ngx-webstorage";
import * as i5 from "../../rating/rating.service";
import * as i6 from "@angular/router";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "./offline-message.service";
import * as i9 from "../../../core/user/user.service";
import * as i10 from "../../../core/tracker/tracker.service";
import * as i11 from "@ngx-translate/core";
import * as i12 from "@angular/platform-browser";
import * as i13 from "../../../core/auth/account.service";
import * as i14 from "@angular/common";
import * as i15 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i16 from "../../../shared/alert/alert.component";
import * as i17 from "../conversation-list/conversation-list.component";
import * as i18 from "./offline-message-control-dropdown/offline-message-control-dropdown.component";
import * as i19 from "../schedule-session/schedule-session.component";
import * as i20 from "../offline-message-ui/offline-message-ui.component";
import * as i21 from "../offline-message-ui/offline-message-send/offline-message-send.component";
import * as i22 from "./customer-care-info.component";
import * as i23 from "@fortawesome/angular-fontawesome";
const _c0 = ["activeSessionAlertModal"];
function InboxComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "conversation-list", 34);
    i0.ɵɵlistener("selectedConv", function InboxComponent_div_3_Template_conversation_list_selectedConv_1_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.setSelectedUser($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("scrolledToBottom", ctx_r0.scrolledToBottom);
} }
function InboxComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.peerLogin(ctx_r1.selectedConversation));
} }
function InboxComponent_offline_message_control_dropdown_19_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "offline-message-control-dropdown", 36);
    i0.ɵɵlistener("messageChange", function InboxComponent_offline_message_control_dropdown_19_Template_offline_message_control_dropdown_messageChange_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.getMessages($event); })("bookSessionChange", function InboxComponent_offline_message_control_dropdown_19_Template_offline_message_control_dropdown_bookSessionChange_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.bookSessionChanging($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedConversation", ctx_r2.selectedConversation)("canBookSession", ctx_r2.canBookSession)("currentAccount", ctx_r2.currentAccount);
} }
function InboxComponent_schedule_session_21_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "schedule-session", 37);
    i0.ɵɵlistener("onHourPressed", function InboxComponent_schedule_session_21_Template_schedule_session_onHourPressed_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.smoothScrollToElement($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedUser", ctx_r3.selectedConversation.user)("currentCoach", ctx_r3.getCoachForSessionSchedule())("sessionId", ctx_r3.customerCareRescheduleSessionId)("mobile", ctx_r3.mobile);
} }
function InboxComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "offline-message-ui", 40);
    i0.ɵɵlistener("messageReceived", function InboxComponent_div_22_Template_offline_message_ui_messageReceived_2_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.messageReceived($event); })("repliedMessage", function InboxComponent_div_22_Template_offline_message_ui_repliedMessage_2_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.repliedMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵelementStart(4, "div", 41);
    i0.ɵɵelementStart(5, "offline-message-send", 42);
    i0.ɵɵlistener("messageSent", function InboxComponent_div_22_Template_offline_message_send_messageSent_5_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.messageSent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("receiver", ctx_r4.peer(ctx_r4.selectedConversation))("session", ctx_r4.session)("selectedConversation", ctx_r4.selectedConversation)("bottomScroll", ctx_r4.bottomScroll);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("selectedUser", ctx_r4.peer(ctx_r4.selectedConversation))("session", ctx_r4.session)("selectedConversation", ctx_r4.selectedConversation)("messageToBeReplied", ctx_r4.messageToBeReplied)("maxCharacterSize", 3000);
} }
function InboxComponent_div_23_customer_care_info_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "customer-care-info", 45);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedConversation", ctx_r26.selectedConversation);
} }
function InboxComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, InboxComponent_div_23_customer_care_info_1_Template, 1, 1, "customer-care-info", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isCustomerCare && ctx_r5.selectedUser);
} }
function InboxComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "conversation-list", 34);
    i0.ɵɵlistener("selectedConv", function InboxComponent_div_26_Template_conversation_list_selectedConv_1_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.setSelectedUser($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !(ctx_r6.view === "conversation" && ctx_r6.isCustomerCare));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("scrolledToBottom", ctx_r6.scrolledToBottom);
} }
function InboxComponent_img_32_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 46);
    i0.ɵɵlistener("click", function InboxComponent_img_32_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.goBackToContacts(); });
    i0.ɵɵelementEnd();
} }
function InboxComponent_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.peerLogin(ctx_r8.selectedConversation));
} }
function InboxComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "fa-icon", 48);
    i0.ɵɵlistener("click", function InboxComponent_div_42_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.displayInfo(ctx_r31.selectedConversation); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function InboxComponent_offline_message_control_dropdown_44_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "offline-message-control-dropdown", 36);
    i0.ɵɵlistener("messageChange", function InboxComponent_offline_message_control_dropdown_44_Template_offline_message_control_dropdown_messageChange_0_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.getMessages($event); })("bookSessionChange", function InboxComponent_offline_message_control_dropdown_44_Template_offline_message_control_dropdown_bookSessionChange_0_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.bookSessionChanging($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedConversation", ctx_r10.selectedConversation)("canBookSession", ctx_r10.canBookSession)("currentAccount", ctx_r10.currentAccount);
} }
function InboxComponent_schedule_session_46_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "schedule-session", 49);
    i0.ɵɵlistener("onHourPressed", function InboxComponent_schedule_session_46_Template_schedule_session_onHourPressed_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.smoothScrollToElement($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedUser", ctx_r11.selectedConversation.user)("currentCoach", ctx_r11.getCoachForSessionSchedule())("sessionId", ctx_r11.customerCareRescheduleSessionId)("mobile", ctx_r11.mobile);
} }
function InboxComponent_div_47_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵelementStart(2, "div", 38);
    i0.ɵɵelementStart(3, "div", 41);
    i0.ɵɵelementStart(4, "offline-message-ui", 40);
    i0.ɵɵlistener("messageReceived", function InboxComponent_div_47_Template_offline_message_ui_messageReceived_4_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.messageReceived($event); })("repliedMessage", function InboxComponent_div_47_Template_offline_message_ui_repliedMessage_4_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.repliedMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "offline-message-send", 50);
    i0.ɵɵlistener("messageSent", function InboxComponent_div_47_Template_offline_message_send_messageSent_5_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.messageSent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("receiver", ctx_r12.peer(ctx_r12.selectedConversation))("session", ctx_r12.session)("selectedConversation", ctx_r12.selectedConversation)("bottomScroll", ctx_r12.bottomScroll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r12.session)("selectedUser", ctx_r12.peer(ctx_r12.selectedConversation))("selectedConversation", ctx_r12.selectedConversation)("messageToBeReplied", ctx_r12.messageToBeReplied)("maxCharacterSize", 3000);
} }
const _c1 = function (a0) { return { coach: a0 }; };
function InboxComponent_ng_template_48_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "h4", 52);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "span", 53);
    i0.ɵɵelement(4, "span", 54);
    i0.ɵɵelement(5, "br");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelement(7, "span", 55);
    i0.ɵɵelement(8, "br");
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "div", 56);
    i0.ɵɵelementStart(11, "button", 57);
    i0.ɵɵlistener("click", function InboxComponent_ng_template_48_Template_button_click_11_listener() { const restoredCtx = i0.ɵɵrestoreView(_r44); const modal_r42 = restoredCtx.$implicit; return modal_r42.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 58);
    i0.ɵɵlistener("click", function InboxComponent_ng_template_48_Template_button_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r44); const modal_r42 = restoredCtx.$implicit; return modal_r42.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r14.sessions[0].coach.login));
} }
const PAGE_LENGTH = 10;
export function convertToMessageSummary(message) {
    if (message) {
        // remove html tags
        message = message.replace(/<.+?>/g, " ");
        // shorten messages longer than 30
        message = message.length > 30 ? message.substring(0, 30) + "..." : message;
    }
    return message;
}
export class InboxComponent extends SessionChatComponent {
    constructor(sessionService, eventManager, messageService, sessionStorage, ratingService, alertService, router, modalService, offlineMessageService, userService, trackerService, translateService, sanitizer, ngZone, accountService, route, elementRef) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, ngZone);
        this.sessionService = sessionService;
        this.eventManager = eventManager;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.ratingService = ratingService;
        this.alertService = alertService;
        this.router = router;
        this.modalService = modalService;
        this.offlineMessageService = offlineMessageService;
        this.userService = userService;
        this.trackerService = trackerService;
        this.translateService = translateService;
        this.sanitizer = sanitizer;
        this.ngZone = ngZone;
        this.accountService = accountService;
        this.route = route;
        this.elementRef = elementRef;
        this.view = 'chat';
        this.modalOptions = { windowClass: 'modal-window', size: 'md' };
        // possible values: "OfflineMessageUiComponent", "ScheduleSessionComponent"
        this.visibleComponent = "OfflineMessageUiComponent";
        this.sessions = [];
        // fakeCoaches = ["Customer Care", "Notification(s)"];
        this.fakeCoaches = ["Customer Care"];
        this.sessionId = this.route.snapshot.params["sessionId"];
        this.isMobile = window.innerWidth < 768;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        this.accountService.getAuthenticationState().subscribe(account => { this.currentAccount = account; });
        this.isCustomerCare = this.accountService.hasAnyAuthority(['ROLE_CUSTOMER_CARE']);
        this.getConversations();
        console.log("InboxComponent.ngOnInit");
        this.currentPage = 0;
        this.first = true;
        this.mobile = true;
        this.users = [];
        console.log("DEBUG: " + this.sessionId);
        this.messageService.setCurrentConversation(this.selectedConversation);
        this.offlineMessageService.setPage.subscribe(() => { this.goFirstPage(); });
        this.subscribeToWebsocket();
        this.scheduleForCustomerCareSubscription = this.eventManager.subscribe('scheduleForCustomerCare', () => {
            this.visibleComponent = "OfflineMessageUiComponent";
        });
        this.rescheduleForCustomerCareSubscription = this.eventManager.subscribe('rescheduleForCustomerCare', (response) => {
            this.customerCareRescheduleSessionId = response.content;
            this.bookSessionChanging(true);
        });
        this.sessionCanceledSubscription = this.eventManager.subscribe("sessionCanceled", () => { this.customerCareRescheduleSessionId = null; });
        // if (!this.accountService.isCoach()) {
        //   this.sessionService.activeSession().subscribe(
        //     (res: HttpResponse<ISession[]>) => {
        //       this.sessions = res.body || [];
        //       if (this.sessions.length > 0) {
        //         this.modalService.open(this.activeSessionAlertModal, { backdrop: 'static' });
        //       }
        //     },
        //     (err: any) => {
        //       console.log(err);
        //     }
        //   );
        // }
    }
    subscribeToWebsocket() {
        this.subscription = this.trackerService.listenerSubject.subscribe(value => {
            const message = value['body'];
            const type = value['type'];
            if (type === 'TYPING') {
                console.log('peer is typing');
                // this.typingMessage = message.senderName + ' is typing ';
                // setTimeout(() => {
                //   this.typingMessage = '';
                // }, 3000);
            }
            else if (type === 'MESSAGE_SEEN') {
            }
            else if (type === 'OFFLINE_MESSAGE_RECEIVED') {
                this.messageReceived(message);
            }
            else {
                console.log('InboxComponent ignoring ' + type + ' message');
            }
        });
    }
    isUnread(c) {
        if (c.lastMessage != null) {
            return c.lastMessage.status === 'DISPLAYED' ||
                !c.lastMessage ||
                c.lastMessage.sessionId != null ||
                c.lastMessage.deleted;
        }
        return false;
    }
    toggleUnread(c) {
        if (this.isRead(c.lastMessage)) {
            c.lastMessage.status = 'RECEIVED';
        }
        else {
            c.lastMessage.status = 'DISPLAYED';
        }
        c.lastMessage = this.convertDate(c.lastMessage);
        c.lastMessage.message = convertToMessageSummary(c.lastMessage.message);
        this.offlineMessageService.updateMessageInfo(c.lastMessage).subscribe(um => {
            console.log(um);
            um.convId = c.id;
            this.sortMessages();
        });
    }
    isRead(m) {
        return m.status === 'DISPLAYED';
    }
    isSelected(c) {
        var _a;
        return ((_a = this.selectedConversation) === null || _a === void 0 ? void 0 : _a.id) === c.id ? '#eef6f4' : '';
    }
    selectConversation(c) {
        console.log("CONV INIT");
        this.selectedConversation = c;
        this.messageService.setCurrentConversation(c);
        if (this.selectedConversation != null && this.selectedConversation.lastMessage != null) {
            this.selectedConversation.lastMessage.status = 'DISPLAYED';
            this.selectedUser = c.user;
            this.view = 'chat';
            this.visibleComponent = "OfflineMessageUiComponent";
            this.messageToBeReplied = null;
            this.sessionStorage.store('userId', this.selectedUser.id);
            this.offlineMessageService.getConversationInfo(this.selectedConversation).subscribe(sc => {
                this.selectedConversation = sc;
                console.log(this.selectedConversation);
                this.userService.findAuthoritiesById(this.selectedConversation.coach.id).subscribe(res => {
                    console.log(res);
                    this.selectedConversation.coach.authorities = res;
                    if (this.currentAccount.authorities.includes('ROLE_USER')) {
                        if (this.selectedConversation.coach.authorities.includes('ROLE_CUSTOMER_CARE')) {
                            let hasEndedSession = this.selectedConversation.lastEndedSession != null;
                            let hasFutureSession = this.selectedConversation.nextSession != null;
                            this.canBookSession = hasEndedSession || hasFutureSession;
                        }
                        else {
                            this.canBookSession = true;
                        }
                    }
                    else if (this.currentAccount.authorities.includes('ROLE_COACH')) {
                        this.canBookSession = this.selectedConversation.coach.login !== 'Notification(s)';
                    }
                    else if (this.currentAccount.authorities.includes('ROLE_CUSTOMER_CARE')) {
                        this.canBookSession = true;
                    }
                    else {
                        this.canBookSession = false;
                    }
                    console.log(this.canBookSession);
                });
            });
            this.eventManager.broadcast({ name: 'selectedConversationChanged', content: this.selectedConversation.user.id });
        }
        else {
            console.log("Selected conversation not found.");
        }
    }
    goBackToContacts() { this.view = 'conversation'; }
    getMessages(a) { this.temp = []; }
    bookSessionChanging(isCoach) {
        this.visibleComponent = "ScheduleSessionComponent";
        this.isCoach = isCoach;
    }
    messageSent(sort) {
        console.log("message sent");
        this.bottomScroll = true;
    }
    messageReceived(message) {
        if (this.getConversationSubscription) {
            // If another getConversation request is in progress, wait for 1 second and retry
            // It prevents concurrent requests for getConversation that can leads to duplicate conversations
            setTimeout(() => {
                this.messageReceived(message);
            }, 1000);
            return;
        }
        message = Object.assign({}, message);
        let x = this.conversations.filter(c => (c.user.id === message.senderId && c.coach.id === message.receiverId) ||
            (c.coach.id === message.senderId && c.user.id === message.receiverId));
        if (x[0]) {
            x[0].lastMessage = this.convertDate(message);
            x[0].lastMessage.message = convertToMessageSummary(x[0].lastMessage.message);
            this.sortMessages();
        }
        else {
            console.log("message is undefined.");
            let peer = this.getPeer(message.senderId, message.receiverId);
            this.getConversationSubscription = this.offlineMessageService.getConversation(peer).subscribe((res) => {
                res.lastMessage = this.convertDate(message);
                res.lastMessage.message = convertToMessageSummary(res.lastMessage.message);
                this.conversations.push(res);
                this.sortMessages();
            }, () => {
            }, () => {
                // clear the subscription to be used for the other messages
                this.getConversationSubscription = null;
            });
        }
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    sortMessages() {
        let unreadList = this.sortDates(this.conversations.filter(c1 => c1.lastMessage != null && c1.lastMessage.status === 'RECEIVED'));
        let readList = this.sortDates(this.conversations.filter(c1 => c1.lastMessage != null && c1.lastMessage.status === 'DISPLAYED'));
        this.conversations = unreadList.concat(readList);
        console.log(this.conversations);
    }
    sortDates(l) {
        l.sort((c1, c2) => {
            let aLastMessage = c1.lastMessage;
            let bLastMessage = c2.lastMessage;
            if (aLastMessage === null) {
                return 1;
            }
            else if (bLastMessage === null) {
                return -1;
            }
            if (aLastMessage.createDate < bLastMessage.createDate) {
                return 1;
            }
            else if (aLastMessage.createDate > bLastMessage.createDate) {
                return -1;
            }
            return 0;
        });
        return l;
    }
    getPage(page) { this.currentPage = page; }
    getConversations() {
        // get all conversations
        let getConversationObservable = this.offlineMessageService.getConversationsOfCurrentUser();
        if (!this.isCustomerCare) {
            // if it's a normal user, just fetch the conversation with Customer care
            getConversationObservable = this.offlineMessageService.getCustomerCareConversationsOfCurrentUser();
        }
        getConversationObservable.subscribe(conversations => {
            for (const c of conversations) {
                if (!c.lastMessage)
                    continue;
                c.lastMessage.message = convertToMessageSummary(c.lastMessage.message);
            }
            this.conversations = conversations;
            if (this.conversations !== null) {
                this.sortMessages();
                this.selectConversation(this.conversations[0]);
                this.numberOfPages = Math.ceil(this.conversations.length / 10);
            }
            else {
                this.numberOfPages = 1;
            }
        });
    }
    next() {
        if (this.currentPage + 1 !== this.numberOfPages) {
            this.currentPage++;
            this.getPage(this.currentPage);
        }
    }
    before() {
        if (this.currentPage !== 0) {
            this.currentPage--;
            this.getPage(this.currentPage);
        }
    }
    go() {
        if (Number(this.goNumber) > 0 && Number(this.goNumber) <= this.roundedLength) {
            this.currentPage = Number(this.goNumber);
            this.getPage(Number(this.goNumber));
        }
    }
    isCurrentUser(userId) { return userId === this.sessionStorage.retrieve('id'); }
    peer(c) { return this.isCurrentUser(c.user.id) ? c.coach : c.user; }
    peerLogin(c) {
        let login = this.peer(c).login;
        return this.translatedUsername(login);
    }
    translatedUsername(login) {
        if (TRANSLATED_LOGINS.includes(login)) {
            login = this.translateService.instant("global." + login);
        }
        return login;
    }
    messageSendDate(c) { return c.lastMessage ? this.dateFormattedNumeric(c.lastMessage.createDate) : ""; }
    messageSendTime(c) { return c.lastMessage ? this.timeFormatted(c.lastMessage.createDate) : ""; }
    displayOfflineMessageUI() { return this.visibleComponent === "OfflineMessageUiComponent"; }
    displayScheduleSessionComponent() { return this.visibleComponent === "ScheduleSessionComponent"; }
    displayInfo(selectedConversation) {
        const modalRef = this.modalService.open(CustomerCareInfoModalComponent, this.modalOptions);
        modalRef.componentInstance.selectedConversation = selectedConversation;
    }
    getCoachForSessionSchedule() {
        if (this.selectedConversation.coach.authorities.includes('ROLE_CUSTOMER_CARE')) {
            return undefined;
        }
        else {
            return this.selectedConversation.coach;
        }
    }
    getStart() { return PAGE_LENGTH * this.currentPage; }
    getEnd() {
        return this.getStart() + PAGE_LENGTH;
    }
    convertDate(m) {
        m.createDate = moment(m.createDate);
        return m;
    }
    goFirstPage() {
        this.currentPage = 0;
    }
    displayCountdownModal() { }
    smoothScrollToElement(elementId) {
        console.log(elementId);
        const scrollToElement = window.setTimeout(() => {
            let element;
            if (!this.isScreenXLg) {
                element = document.getElementById('schedule-session-mobile');
            }
            else {
                element = document.getElementById('schedule-session-desktop');
            }
            element.scrollTop = 0;
        }, 100);
    }
    setSelectedUser(event) {
        this.getConversationItemSelected(event);
        this.view = 'chat';
    }
    //  THIS GETS THE SELECTED ITEM FROM CONVERSATION LIST CARD
    getConversationItemSelected(conversation) {
        console.log(conversation);
        // if there is no previous value for this.conversation, it means this is the first conversation that is selected automatically
        // if there is a value for this.conversation, it means the user has selected this conversation manually
        this.isConversationAutomaticallySelected = !this.selectedConversation;
        this.selectedConversation = conversation;
        if (this.isConversationAutomaticallySelected && !this.isScreenLg) {
            // there is no need to automatically select the conversation on mobile size
            return;
        }
        if (!this.selectedUser || this.selectedUser.id !== this.selectedConversation.user.id) {
            this.selectedUser = this.selectedConversation.user;
            this.session = null;
        }
    }
    ngOnDestroy() {
        var _a;
        super.ngOnDestroy();
        if (this.subscription)
            this.subscription.unsubscribe();
        if (this.getConversationSubscription)
            (_a = this.getConversationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        if (this.scheduleForCustomerCareSubscription)
            this.scheduleForCustomerCareSubscription.unsubscribe();
        if (this.rescheduleForCustomerCareSubscription)
            this.rescheduleForCustomerCareSubscription.unsubscribe();
    }
}
InboxComponent.ɵfac = function InboxComponent_Factory(t) { return new (t || InboxComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i3.MessageService), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.RatingService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i6.Router), i0.ɵɵdirectiveInject(i7.NgbModal), i0.ɵɵdirectiveInject(i8.OfflineMessageService), i0.ɵɵdirectiveInject(i9.UserService), i0.ɵɵdirectiveInject(i10.TrackerService), i0.ɵɵdirectiveInject(i11.TranslateService), i0.ɵɵdirectiveInject(i12.DomSanitizer), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i13.AccountService), i0.ɵɵdirectiveInject(i6.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ElementRef)); };
InboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InboxComponent, selectors: [["offline-message"]], viewQuery: function InboxComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.activeSessionAlertModal = _t.first);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 51, vars: 14, consts: [[1, "olha-theme", 2, "margin-top", "90px", "height", "85vh"], [1, "d-none", "d-xl-block", "h-100"], [1, "d-flex", "justify-content-center", "h-100"], ["class", "col-xl-3 mr-xl-4 h-100 chat-ui-part", 4, "ngIf"], [1, "col-xl-5", "h-100", "px-xl-4", "chat-ui-part"], [1, "p-2", "h-100", 2, "display", "flex", "flex-direction", "column"], [1, "row", 2, "display", "flex", "justify-content", "space-between", "padding-top", "5px"], ["id", "current-chat-menu", 2, "padding-left", "20px"], [1, "float-left", "pr-2"], ["src", "../../../../../../../../../content/images/inuka/logo-circle.png", "alt", "logo-circle", 2, "width", "auto", "height", "2.5rem", "line-height", "16.5rem", "font-size", "1rem"], ["class", "text-default", "style", "line-height: 3rem; vertical-align: middle", 4, "ngIf"], [1, "dropdown-menu", "dropdown-menu-left"], ["onclick", "", "jhiTranslate", "sessionChat.paragraph.current", 2, "background-color", "white", "border", "none"], ["id", "get-past-sessions", "jhiTranslate", "sessionChat.paragraph.past", 2, "background-color", "white", "border", "none", "opacity", "0.3"], ["id", "get-test-results", "jhiTranslate", "sessionChat.paragraph.wellbeing", 2, "background-color", "white", "border", "none", "opacity", "0.3"], [2, "padding-right", "20px"], [3, "selectedConversation", "canBookSession", "currentAccount", "messageChange", "bookSessionChange", 4, "ngIf"], [2, "margin", "10px 0 10px 0"], ["id", "schedule-session-desktop", "style", "position: relative; flex: 1 1 0; overflow: auto;", 3, "selectedUser", "currentCoach", "sessionId", "mobile", "onHourPressed", 4, "ngIf"], ["style", "position: relative; flex: 1 1 0", 4, "ngIf"], ["class", "col-xl-3 ml-xl-4 h-100 chat-ui-part", 4, "ngIf"], [1, "d-xl-none", "h-100"], [1, "justify-content-center", "h-100"], ["class", "col-12 col-sm-10 col-md-8 col-lg-8 h-100 chat-ui-part m-auto", 3, "hidden", 4, "ngIf"], [1, "col-12", "col-sm-10", "col-md-8", "col-lg-8", "h-100", "chat-ui-part", "m-auto", 3, "hidden"], [1, "row", 2, "padding-left", "20px"], ["src", "../../../../../../../../../content/images/inuka/back-arrow-active-xhdpi.png", "alt", "", 3, "click", 4, "ngIf"], ["src", "../../../../../../../../../content/images/inuka/logo-circle.png", "alt", "", 1, "ml-2", 2, "width", "auto", "height", "2.5rem", "line-height", "16.5rem", "font-size", "1rem"], ["jhiTranslate", "sessionChat.paragraph.past", 2, "background-color", "white", "border", "none", "opacity", "0.3"], ["jhiTranslate", "sessionChat.paragraph.wellbeing", 2, "background-color", "white", "border", "none", "opacity", "0.3"], ["role", "button", "style", "padding: 5px;", 4, "ngIf"], ["id", "schedule-session-mobile", 3, "selectedUser", "currentCoach", "sessionId", "mobile", "onHourPressed", 4, "ngIf"], ["activeSessionAlertModal", ""], [1, "col-xl-3", "mr-xl-4", "h-100", "chat-ui-part"], [3, "scrolledToBottom", "selectedConv"], [1, "text-default", 2, "line-height", "3rem", "vertical-align", "middle"], [3, "selectedConversation", "canBookSession", "currentAccount", "messageChange", "bookSessionChange"], ["id", "schedule-session-desktop", 2, "position", "relative", "flex", "1 1 0", "overflow", "auto", 3, "selectedUser", "currentCoach", "sessionId", "mobile", "onHourPressed"], [2, "position", "relative", "flex", "1 1 0"], [2, "position", "absolute", "left", "0", "right", "0", "display", "flex", "flex-direction", "column", "height", "85%"], [2, "height", "100%", 3, "receiver", "session", "selectedConversation", "bottomScroll", "messageReceived", "repliedMessage"], [2, "position", "absolute", "left", "0", "right", "0", "display", "flex", "flex-direction", "column", "height", "100%"], [3, "selectedUser", "session", "selectedConversation", "messageToBeReplied", "maxCharacterSize", "messageSent"], [1, "col-xl-3", "ml-xl-4", "h-100", "chat-ui-part"], [3, "selectedConversation", 4, "ngIf"], [3, "selectedConversation"], ["src", "../../../../../../../../../content/images/inuka/back-arrow-active-xhdpi.png", "alt", "", 3, "click"], ["role", "button", 2, "padding", "5px"], ["icon", "info-circle", 1, "info-circle", "fa-2x", 3, "click"], ["id", "schedule-session-mobile", 3, "selectedUser", "currentCoach", "sessionId", "mobile", "onHourPressed"], [3, "session", "selectedUser", "selectedConversation", "messageToBeReplied", "maxCharacterSize", "messageSent"], [1, "modal-body", 2, "background-color", "white", "overflow-wrap", "break-word", "border-radius", "0.3rem"], ["jhiTranslate", "sessionChat.started", 1, "modal-title", 2, "font-weight", "bold", "text-align", "center"], ["jhiTranslate", "sessionChat.readyToJoin", 3, "translateValues"], ["jhiTranslate", "sessionChat.notSeeMessages"], ["jhiTranslate", "sessionChat.toHomeScreen"], [1, "alert-box-actions", 2, "text-align", "center"], ["type", "button", "routerLink", "/index-user", "jhiTranslate", "sessionChat.home", 1, "btn", "btn-gradient-primary", "font-weight-bold", 2, "margin", "5px", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.cancel", 1, "btn", "btn-dark", 2, "margin", "5px", 3, "click"]], template: function InboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, InboxComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelement(9, "img", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, InboxComponent_span_10_Template, 2, 1, "span", 10);
        i0.ɵɵelementStart(11, "ul", 11);
        i0.ɵɵelementStart(12, "li");
        i0.ɵɵelement(13, "a", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "li");
        i0.ɵɵelement(15, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "li");
        i0.ɵɵelement(17, "a", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 15);
        i0.ɵɵtemplate(19, InboxComponent_offline_message_control_dropdown_19_Template, 1, 3, "offline-message-control-dropdown", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "hr", 17);
        i0.ɵɵtemplate(21, InboxComponent_schedule_session_21_Template, 1, 4, "schedule-session", 18);
        i0.ɵɵtemplate(22, InboxComponent_div_22_Template, 6, 9, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(23, InboxComponent_div_23_Template, 2, 1, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 21);
        i0.ɵɵelementStart(25, "div", 22);
        i0.ɵɵtemplate(26, InboxComponent_div_26_Template, 2, 2, "div", 23);
        i0.ɵɵelementStart(27, "div", 24);
        i0.ɵɵelementStart(28, "div", 5);
        i0.ɵɵelementStart(29, "div", 6);
        i0.ɵɵelementStart(30, "div", 25);
        i0.ɵɵelementStart(31, "div", 8);
        i0.ɵɵtemplate(32, InboxComponent_img_32_Template, 1, 0, "img", 26);
        i0.ɵɵelement(33, "img", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(34, InboxComponent_span_34_Template, 2, 1, "span", 10);
        i0.ɵɵelementStart(35, "ul", 11);
        i0.ɵɵelementStart(36, "li");
        i0.ɵɵelement(37, "a", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "li");
        i0.ɵɵelement(39, "a", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "li");
        i0.ɵɵelement(41, "a", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(42, InboxComponent_div_42_Template, 2, 0, "div", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 15);
        i0.ɵɵtemplate(44, InboxComponent_offline_message_control_dropdown_44_Template, 1, 3, "offline-message-control-dropdown", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(45, "hr", 17);
        i0.ɵɵtemplate(46, InboxComponent_schedule_session_46_Template, 1, 4, "schedule-session", 31);
        i0.ɵɵtemplate(47, InboxComponent_div_47_Template, 6, 9, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(48, InboxComponent_ng_template_48_Template, 13, 3, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(50, "jhi-alert");
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isCustomerCare && !ctx.isMobile);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.selectedUser);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.selectedConversation);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.visibleComponent === "ScheduleSessionComponent");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.visibleComponent === "OfflineMessageUiComponent" && ctx.selectedUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCustomerCare);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.view !== "chat");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isCustomerCare);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedUser);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.isCustomerCare && ctx.selectedUser);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedConversation);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayScheduleSessionComponent());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.visibleComponent === "OfflineMessageUiComponent" && ctx.selectedUser);
    } }, directives: [i14.NgIf, i15.JhiTranslateDirective, i16.AlertComponent, i17.ConversationListComponent, i18.OfflineMessageControlDropdownComponent, i19.ScheduleSessionComponent, i20.OfflineMessageUiComponent, i21.OfflineMessageSendComponent, i22.CustomerCareInfoComponent, i23.FaIconComponent, i6.RouterLink], styles: [".container[_ngcontent-%COMP%]{margin-top:50px}.conversation-feed[_ngcontent-%COMP%]{padding-top:7px !important;padding-bottom:7px !important;position:absolute;bottom:-9px;right:0}.unread-toggle-icon[_ngcontent-%COMP%]{color:#6c757d;font-size:11px;border:1px solid #6c757d;border-radius:2px;padding:2px 2px 0 2px}.chat-ui-part[_ngcontent-%COMP%]{background-color:#fff;border-radius:20px;min-height:100%;position:relative !important}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}@media(min-width: 992px){.container[_ngcontent-%COMP%]{padding-bottom:96px}}@media(max-width: 992px){.container[_ngcontent-%COMP%]{padding-top:64px;padding-bottom:0}}.paginationjs[_ngcontent-%COMP%]{line-height:1.6;font-family:\"Marmelad\",\"Lucida Grande\",\"Arial\",\"Hiragino Sans GB\",Georgia,sans-serif;font-size:14px;box-sizing:initial}.paginationjs[_ngcontent-%COMP%]:after{display:table;content:\" \";clear:both}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]{float:left}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{float:left;margin:0;padding:0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left;border:1px solid #aaa;border-right:none;list-style:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:30px;height:28px;line-height:28px;display:block;background:#fff;font-size:14px;color:#333;text-decoration:none;text-align:center}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#eee}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{border:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:30px;line-height:30px;background:#aaa;color:#fff}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{opacity:.3}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{border-radius:3px 0 0 3px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child > a[_ngcontent-%COMP%]{border-radius:3px 0 0 3px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-right:1px solid #aaa;border-radius:0 3px 3px 0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child > a[_ngcontent-%COMP%]{border-radius:0 3px 3px 0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{float:left;margin-left:10px;font-size:14px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:30px;height:28px;background:#fff;border-radius:3px;border:1px solid #aaa;padding:0;font-size:14px;text-align:center;vertical-align:baseline;outline:none;box-shadow:none;box-sizing:initial}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{float:left;margin-left:10px;font-size:14px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:40px;height:30px;line-height:28px;background:#fff;border-radius:3px;border:1px solid #aaa;text-align:center;padding:0 8px;font-size:14px;vertical-align:baseline;outline:none;box-shadow:none;color:#333;cursor:pointer}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#f8f8f8}.paginationjs[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{float:left;height:30px;line-height:30px;margin-left:10px;font-size:14px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:26px;height:24px;line-height:24px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:26px;line-height:26px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:26px;height:24px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:30px;height:26px;line-height:24px;padding:0 6px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{height:26px;line-height:26px;font-size:12px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:36px;height:34px;line-height:34px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:36px;line-height:36px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:36px;height:34px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:50px;height:36px;line-height:34px;padding:0 12px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{height:36px;line-height:36px;font-size:16px}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#e9f4fc}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#289de9;color:#fff}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#289de9;border-color:#289de9;color:#fff}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#3ca5ea}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#ebf4eb}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#449d44;color:#fff}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#449d44;border-color:#449d44;color:#fff}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#55a555}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#fdf5e9}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#ec971f;color:#fff}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#ec971f;border-color:#ec971f;color:#fff}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#eea135}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#faeaea}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#c9302c;color:#fff}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#c9302c;border-color:#c9302c;color:#fff}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#ce4541}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.paginationjs-next[_ngcontent-%COMP%]{*border-right:1px solid #aaa;border-right:1px solid}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{margin-left:5px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{line-height:28px;vertical-align:middle}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{margin-left:5px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{vertical-align:middle}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{line-height:36px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{height:35px;line-height:36px}"] });
